import { ReactElement, Suspense } from 'react';
import { Provider } from 'react-redux';

import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import { ConfigProvider } from 'antd';
import { store } from 'store';
import { amplifyTheme, antdTheme } from 'theme';

import { Router } from 'router/Router';
import { AuthHeader } from 'views/components';

import '@aws-amplify/ui-react/styles.css';

const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider theme={antdTheme}>
        <ThemeProvider theme={amplifyTheme}>
          <Suspense>
            <Authenticator
              loginMechanisms={['email']}
              hideSignUp={true}
              components={{
                Header(): ReactElement {
                  return <AuthHeader />;
                },
              }}
            >
              <Router />
            </Authenticator>
          </Suspense>
        </ThemeProvider>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
